import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_UPDATE_EDIT_ACCOUNT_LOCK_BEGIN,
  MANAGE_SUBS_UPDATE_EDIT_ACCOUNT_LOCK_SUCCESS,
  MANAGE_SUBS_UPDATE_EDIT_ACCOUNT_LOCK_FAILURE,
  MANAGE_SUBS_UPDATE_EDIT_ACCOUNT_LOCK_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';
export function updateEditAccountLock(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_UPDATE_EDIT_ACCOUNT_LOCK_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/updateEditAccountLock`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          const data = res.data;
          dispatch({
            type: MANAGE_SUBS_UPDATE_EDIT_ACCOUNT_LOCK_SUCCESS,
            data: data,
          });
          resolve(data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_UPDATE_EDIT_ACCOUNT_LOCK_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateEditAccountLockError() {
  return {
    type: MANAGE_SUBS_UPDATE_EDIT_ACCOUNT_LOCK_DISMISS_ERROR,
  };
}

export function useUpdateEditAccountLock() {
  const dispatch = useDispatch();

  const { updateEditAccountLockPending, updateEditAccountLockError } = useSelector(
    state => ({
      updateEditAccountLockPending: state.manageSubs.updateEditAccountLockPending,
      updateEditAccountLockError: state.manageSubs.updateEditAccountLockError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(updateEditAccountLock(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissUpdateEditAccountLockError());
  }, [dispatch]);

  return {
    updateEditAccountLock: boundAction,
    updateEditAccountLockPending,
    updateEditAccountLockError,
    dismissUpdateEditAccountLockError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_UPDATE_EDIT_ACCOUNT_LOCK_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        updateEditAccountLockPending: true,
        updateEditAccountLockError: null,
      };

    case MANAGE_SUBS_UPDATE_EDIT_ACCOUNT_LOCK_SUCCESS:
      // The request is success
      return {
        ...state,
        updateEditAccountLockPending: false,
        updateEditAccountLockError: null,
      };

    case MANAGE_SUBS_UPDATE_EDIT_ACCOUNT_LOCK_FAILURE:
      // The request is failed
      return {
        ...state,
        updateEditAccountLockPending: false,
        updateEditAccountLockError: action.data.error,
      };

    case MANAGE_SUBS_UPDATE_EDIT_ACCOUNT_LOCK_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        updateEditAccountLockError: null,
      };

    default:
      return state;
  }
}
